import { PROMOS_REQUEST_ERROR } from '../../constants/notifications';
import { resolveSearchPromosPage } from '../../services/promosSearch';
import { TThunkAction } from '../../types/redux/thunk';
import { getLocationPath } from '../../utils/url';
import { trackNewPageAction } from '../analytics';
import { updateBrowserHistory } from '../browserHistory';
import { setError } from '../error';
import { promosFailure, promosRequest, promosSuccess } from '../promos/actions';

/**
 * Redux action, который запрашивает объявления с текущем состоянием nextJsonQuery
 */
export const promosRequestAction = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const { logger, httpApi, custom } = context;

  const state = getState();
  const nextJsonQuery = state.nextJsonQuery;
  const subdomain = custom.subdomain;
  const path = getLocationPath();

  try {
    dispatch(promosRequest());

    const newData = await resolveSearchPromosPage({
      httpApi,
      logger,
      jsonQuery: nextJsonQuery,
      subdomain,
      path,
    });

    dispatch(promosSuccess(newData));
    dispatch(updateBrowserHistory());
    dispatch(trackNewPageAction());
  } catch (e) {
    dispatch(promosFailure());

    dispatch(setError({ id: Date.now(), message: PROMOS_REQUEST_ERROR }));

    throw e;
  }
};
